// Modal.js
import React from 'react';
import '../styles/modal.css'
import { FaTimes } from 'react-icons/fa';

const Modal = ({ isOpen, onClose, contentComponent: Content, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay ">
      <div className="modal-content bg-light2 dark:bg-dark2 space-y-4 ">
        <div className='flex justify-end'>
            <button className='text-dark0 dark:text-light1 rounded-full hover:bg-light1 dark:hover:bg-dark2 hover:text-primary dark:hover:text-primary border border-light1 dark:hover:border-primary  p-2' onClick={onClose}><FaTimes/></button>
        </div>
        {Content ? <Content /> : children}
      </div>
    </div>
  );
};

export default Modal;
